import { render, staticRenderFns } from "./BaseHeaderDashboard.vue?vue&type=template&id=13e5b1f0&scoped=true"
import script from "./BaseHeaderDashboard.vue?vue&type=script&lang=js"
export * from "./BaseHeaderDashboard.vue?vue&type=script&lang=js"
import style0 from "./BaseHeaderDashboard.vue?vue&type=style&index=0&id=13e5b1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e5b1f0",
  null
  
)

export default component.exports